<template>
  <div>
    <CustomTable 
      :first-cell-image="true" 
      :custom-class="`view-players-table distance-players-table double-image `">
      <template slot="theader">
        <TableRow>
          <TableCell :class="{'fixed-column first-col':scrollLeftOver25}">
            <div class="gear-btn-wrapper gear-stats">
              <b-btn :id="'metricInfoPopover_DistanceSpeedStatsTable'" :class="'popover-btn'">
                <img src="@/assets/images/icons/gear-icon.png" alt="unit settings icon">
              </b-btn>

              <div class="custom-popover table-settings-popover" id="popoverPlacement_DistanceStatsTable"></div>

              <b-popover 
                :target="'metricInfoPopover_DistanceSpeedStatsTable'" 
                triggers="click blur" 
                placement="bottomright"
                container="popoverPlacement_DistanceStatsTable">

                <div class="popover-content">
                  <div class="table-setting-row">
                    <div class="row-content">
                      {{ $t('CALENDAR_ACTIVITY.playerStatsTables.distanceSpeedTable.speedZones') }}
                      <div 
                        class="btn-group calendar-view-filter switch-btn-group switch-btn-group-orange fa-pull-right" 
                        @click="changeDistanceZonesUnitOnClick()">
                        <label 
                          class="btn" 
                          :class="{ 'active': distanceZonesSelectedUnit === distanceZoneUnits.PERCENTAGE }">%</label>
                        <label 
                          class="btn" 
                          :class="{ 'active': distanceZonesSelectedUnit === distanceZoneUnits.METERS }">{{unitLabel}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </b-popover>
            </div>
            <!-- Player -->
            <span :class="{'d-none':scrollLeftOver25}">
              {{ $t('CALENDAR_ACTIVITY.playerStatsTables.distanceSpeedTable.player') }}
            </span>
          </TableCell>
          <!-- Distance -->
          <TableCell>{{ $t('CALENDAR_ACTIVITY.playerStatsTables.distanceSpeedTable.distance') }}</TableCell>
          <!-- Low Intensity -->
          <TableCell :custom-classes="'blue-column'">{{ $t('CALENDAR_ACTIVITY.playerStatsTables.distanceSpeedTable.low') }}</TableCell>
          <!-- Medium Intensity -->
          <TableCell :custom-classes="'green-column'">{{ $t('CALENDAR_ACTIVITY.playerStatsTables.distanceSpeedTable.medium') }}</TableCell>
          <!-- High Intensity -->
          <TableCell :custom-classes="'orange-column'">{{ $t('CALENDAR_ACTIVITY.playerStatsTables.distanceSpeedTable.high') }}</TableCell>
          <!-- Max Intensity -->
          <TableCell :custom-classes="'red-column'">{{ $t('CALENDAR_ACTIVITY.playerStatsTables.distanceSpeedTable.max') }}</TableCell>
          <!-- Top Speed -->
          <TableCell>{{ $t('CALENDAR_ACTIVITY.playerStatsTables.distanceSpeedTable.topSpeed') }}</TableCell>
          <!-- % at High Speed -->
          <TableCell>{{ $t('CALENDAR_ACTIVITY.playerStatsTables.distanceSpeedTable.atHighSpeed') }}</TableCell>
        </TableRow>
      </template>
    </CustomTable>

    <CustomTable
      :first-cell-image="true"
      :custom-class="`accordion-table view-players-table distance-players-table double-image`">
      <template slot="tbody">
        <TableRow>
          <TableCell :class="{'fixed-column data-col':scrollLeftOver25}">
            <PlayerInvalidActivityIcon :activity-status="activityInfo.status" />

            <span class="battery-warnings" v-if="!scrollLeftOver25 && activityInfo.batteryLevelIsLow" v-b-tooltip="{
                title: this.$t('CALENDAR_ACTIVITY.playerStatsTables.batteryWarningsTooltip') ,
                container: 'body',
                boundary: 'viewport',
                trigger: 'hover',
                template: tooltipTemplate,
                placement: 'topright'
              }">
              <img src="@/assets/images/activity/10_battery.png" alt="battery warning">
            </span>

            <span 
              v-if="!scrollLeftOver25 && activityInfo.sensorError"
              v-b-tooltip="{
                title: this.$t('CALENDAR_ACTIVITY.playerStatsTables.sensorError'),
                container: 'body',
                boundary: 'viewport',
                trigger: 'hover',
                template: tooltipTemplate,
                placement: 'topright'
              }"
              class="other-img error-icon cursor-pointer text-error">
              <i class="fas fa-minus-circle" aria-hidden="true"></i>
            </span>

            <img class="player-icon cell-img" v-if="activityInfo.playerPhoto" :src="activityInfo.playerPhoto" alt="player photo" />

            <CustomEmblem 
              v-if="!activityInfo.playerPhoto"
              :gender="activityInfo.playerGender"
              :sub-header="[activityInfo.playerFirstName, activityInfo.playerLastName]"
              :custom-classes="'cell-img'" 
              id="tooltip-player-ds"/>
              <span :class="{'d-none':scrollLeftOver25}">
                {{ activityInfo.playerFirstName }} {{ activityInfo.playerLastName }}
              </span>
              <b-tooltip v-if="scrollLeftOver25" target="tooltip-player-ds" triggers="hover">
                {{activityInfo.playerFirstName}} {{activityInfo.playerLastName}}
              </b-tooltip>
          </TableCell>
          <!-- Distance -->
          <TableCell>
            <template v-if="data.invalid">
              {{$t('COMMON.notApplicable')}}
            </template>
            <template v-if="data.distance != null && !data.invalid">{{ data.distance | distance(unitSystem) }}</template>
            <template v-if="data.distance === null && !data.invalid">{{$t('COMMON.notApplicable')}}</template>
          </TableCell>
          <!-- Low Intensity -->
          <TableCell :custom-classes="'blue-column'">
            <template v-if="data.invalid">
              {{$t('COMMON.notApplicable')}}
            </template>

            <template v-if="distanceZonesSelectedUnit === distanceZoneUnits.PERCENTAGE && !data.invalid">
              <template v-if="data.distanceZone1Percentage != null">{{ `${data.distanceZone1Percentage}%` }}</template>
              <template v-if="data.distanceZone1Percentage === null">{{$t('COMMON.notApplicable')}}</template>
            </template>

            <template v-if="distanceZonesSelectedUnit === distanceZoneUnits.METERS && !data.invalid">
              <template v-if="data.distanceZone1 != null">{{ data.distanceZone1 | distance(unitSystem) }}</template>
              <template v-if="data.distanceZone1 === null">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <!-- Medium Intensity -->
          <TableCell :custom-classes="'green-column'">
            <template v-if="data.invalid">
              {{$t('COMMON.notApplicable')}}
            </template>

            <template v-if="distanceZonesSelectedUnit === distanceZoneUnits.PERCENTAGE && !data.invalid">
              <template v-if="data.distanceZone2Percentage != null">{{ `${data.distanceZone2Percentage}%` }}</template>
              <template v-if="data.distanceZone2Percentage === null">{{$t('COMMON.notApplicable')}}</template>
            </template>

            <template v-if="distanceZonesSelectedUnit === distanceZoneUnits.METERS && !data.invalid">
              <template v-if="data.distanceZone2 != null">{{ data.distanceZone2 | distance(unitSystem) }}</template>
              <template v-if="data.distanceZone2 === null">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <!-- High Intensity -->
          <TableCell :custom-classes="'orange-column'">
            <template v-if="data.invalid">
              {{$t('COMMON.notApplicable')}}
            </template>

            <template v-if="distanceZonesSelectedUnit === distanceZoneUnits.PERCENTAGE && !data.invalid">
              <template v-if="data.distanceZone3Percentage != null">{{ `${data.distanceZone3Percentage}%` }}</template>
              <template v-if="data.distanceZone3Percentage === null">{{$t('COMMON.notApplicable')}}</template>
            </template>

            <template v-if="distanceZonesSelectedUnit === distanceZoneUnits.METERS && !data.invalid">
              <template v-if="data.distanceZone3 != null">{{ data.distanceZone3 | distance(unitSystem) }}</template>
              <template v-if="data.distanceZone3 === null">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <!-- Max Intensity -->
          <TableCell :custom-classes="'red-column'">
            <template v-if="data.invalid">
              {{$t('COMMON.notApplicable')}}
            </template>

            <template v-if="distanceZonesSelectedUnit === distanceZoneUnits.PERCENTAGE && !data.invalid">
              <template v-if="data.distanceZone4Percentage != null">{{ `${data.distanceZone4Percentage}%` }}</template>
              <template v-if="data.distanceZone4Percentage === null">{{$t('COMMON.notApplicable')}}</template>
            </template>

            <template v-if="distanceZonesSelectedUnit === distanceZoneUnits.METERS && !data.invalid">
              <template v-if="data.distanceZone4 != null">{{ data.distanceZone4 | distance(unitSystem) }}</template>
              <template v-if="data.distanceZone4 === null">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <!-- Top Speed -->
          <TableCell>{{ data.topSpeedPercentage != null ? `${data.topSpeedPercentage}%` : $t('COMMON.notApplicable') }}</TableCell>
          <!-- % at High Speed -->
          <TableCell>{{ data.percentageAtHighSpeed != null ? `${data.percentageAtHighSpeed}%` : $t('COMMON.notApplicable') }}</TableCell>
        </TableRow>
      </template>
    </CustomTable>

    <!-- Segments Table -->
    <CustomTable
      v-for="segment in statsSegment"
      :key="segment.id"
      :first-cell-image="true"
      :custom-class="`accordion-table view-players-table distance-players-table double-image`">
      <template slot="tbody">
        <TableRow>
          <!-- Player Segment -->
          <TableCell :class="{'fixed-column data-col':scrollLeftOver25}">
            <PlayerInvalidActivityIcon :activity-status="activityInfo.status" />

            <img class="player-icon cell-img" v-if="activityInfo.playerPhoto" :src="activityInfo.playerPhoto" alt="player photo" />

            <CustomEmblem 
              v-if="!activityInfo.playerPhoto"
              :gender="activityInfo.playerGender"
              :sub-header="[activityInfo.playerFirstName, activityInfo.playerLastName]"
              :custom-classes="'cell-img'" 
              id="tooltip-segment-ds"/>
            <span :class="{'d-none':scrollLeftOver25}">
              {{segment.name}} ({{(segment.endPoint - segment.startPoint) | secondsToMinutesSeconds}})
            </span>
            <b-tooltip v-if="scrollLeftOver25" target="tooltip-segment-ds" triggers="hover">
              {{activityInfo.playerFirstName}} {{activityInfo.playerLastName}}
            </b-tooltip>
          </TableCell>
          <!-- Distance Segment -->
          <TableCell>
            <template v-if="data.invalid">
              {{$t('COMMON.notApplicable')}}
            </template>
            <template v-if="!data.invalid">
              <template v-if="segment.segmentStats.distance != null">{{ segment.segmentStats.distance | distance(unitSystem) }}</template>
              <template v-if="segment.segmentStats.distance === null">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <!-- Low Intensity Segment -->
          <TableCell :custom-classes="'blue-column'">
            <template v-if="data.invalid">
              {{$t('COMMON.notApplicable')}}
            </template>

            <template v-if="distanceZonesSelectedUnit === distanceZoneUnits.PERCENTAGE && !data.invalid">
              <template v-if="segment.segmentStats.distanceZone1Percentage != null">{{ `${segment.segmentStats.distanceZone1Percentage}%` }}</template>
              <template v-if="segment.segmentStats.distanceZone1Percentage === null">{{$t('COMMON.notApplicable')}}</template>
            </template>

            <template v-if="distanceZonesSelectedUnit === distanceZoneUnits.METERS && !data.invalid">
              <template v-if="segment.segmentStats.distanceZone1 != null">{{ segment.segmentStats.distanceZone1 | distance(unitSystem) }}</template>
              <template v-if="segment.segmentStats.distanceZone1 === null">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <!-- Medium Intensity Segments -->
          <TableCell :custom-classes="'green-column'">
            <template v-if="data.invalid">
              {{$t('COMMON.notApplicable')}}
            </template>

            <template v-if="distanceZonesSelectedUnit === distanceZoneUnits.PERCENTAGE && !data.invalid">
              <template v-if="segment.segmentStats.distanceZone2Percentage != null">{{ `${segment.segmentStats.distanceZone2Percentage}%` }}</template>
              <template v-if="segment.segmentStats.distanceZone2Percentage === null">{{$t('COMMON.notApplicable')}}</template>
            </template>

            <template v-if="distanceZonesSelectedUnit === distanceZoneUnits.METERS && !data.invalid">
              <template v-if="segment.segmentStats.distanceZone2 != null">{{ segment.segmentStats.distanceZone2 | distance(unitSystem) }}</template>
              <template v-if="segment.segmentStats.distanceZone2 === null">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <!-- High Intensity Segments -->
          <TableCell :custom-classes="'orange-column'">
            <template v-if="data.invalid">
              {{$t('COMMON.notApplicable')}}
            </template>

            <template v-if="distanceZonesSelectedUnit === distanceZoneUnits.PERCENTAGE && !data.invalid">
              <template v-if="segment.segmentStats.distanceZone3Percentage != null">{{ `${segment.segmentStats.distanceZone3Percentage}%` }}</template>
              <template v-if="segment.segmentStats.distanceZone3Percentage === null">{{$t('COMMON.notApplicable')}}</template>
            </template>

            <template v-if="distanceZonesSelectedUnit === distanceZoneUnits.METERS && !data.invalid">
              <template v-if="segment.segmentStats.distanceZone3 != null">{{ segment.segmentStats.distanceZone3 | distance(unitSystem) }}</template>
              <template v-if="segment.segmentStats.distanceZone3 === null">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <!-- Max Intensity Segments -->
          <TableCell :custom-classes="'red-column'">
            <template v-if="data.invalid">
              {{$t('COMMON.notApplicable')}}
            </template>

            <template v-if="distanceZonesSelectedUnit === distanceZoneUnits.PERCENTAGE && !data.invalid">
              <template v-if="segment.segmentStats.distanceZone4Percentage != null">{{ `${segment.segmentStats.distanceZone4Percentage}%` }}</template>
              <template v-if="segment.segmentStats.distanceZone4Percentage === null">{{$t('COMMON.notApplicable')}}</template>
            </template>

            <template v-if="distanceZonesSelectedUnit === distanceZoneUnits.METERS && !data.invalid">
              <template v-if="segment.segmentStats.distanceZone4 != null">{{ segment.segmentStats.distanceZone4 | distance(unitSystem) }}</template>
              <template v-if="segment.segmentStats.distanceZone4 === null">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <!-- Top Speed Segments -->
          <TableCell>
            {{ segment.segmentStats.topSpeedPercentage != null ? `${segment.segmentStats.topSpeedPercentage}%` : $t('COMMON.notApplicable') }}
          </TableCell>
          <!-- % at High Speed Segments -->
          <TableCell>
            {{ segment.segmentStats.percentageAtHighSpeed != null ? `${segment.segmentStats.percentageAtHighSpeed}%` : $t('COMMON.notApplicable') }}
          </TableCell>
        </TableRow>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import { SESSION_METRICS } from '@/constants/SessionConsts'
import { CustomTable, TableRow, TableCell } from '@/components/common/table'
import CustomEmblem from '@/components/common/CustomEmblem'
import { DISTANCE_ZONES_UNITS } from '@/constants/SessionConsts'
import PlayerInvalidActivityIcon from '@/components/calendar-activity/PlayerInvalidActivityIcon'
import { getUnitLabel } from '../../common/helper'

export default {
  name: 'DistanceSpeedStatsTable',
  props: [
    'data',
    'activityInfo',
    'changeDistanceZonesUnit',
    'distanceZonesSelectedUnit',
    'statsSegment',
    'scrollLeftOver25',
    'account'
  ],
  data () {
    return {
      distanceZoneUnits: DISTANCE_ZONES_UNITS,
      SESSION_METRICS: SESSION_METRICS,
      tooltipTemplate: '<div class="tooltip event-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
      unitSystem: this.account.unitDistance,
      unitLabel: getUnitLabel(this.account.unitDistance)      
    }
  },
  methods: {
    changeDistanceZonesUnitOnClick () {
      const newUnit = this.distanceZonesSelectedUnit === this.distanceZoneUnits.PERCENTAGE ? this.distanceZoneUnits.METERS : this.distanceZoneUnits.PERCENTAGE
      this.changeDistanceZonesUnit(newUnit)
    }
  },
  components: {
    CustomTable,
    TableRow,
    TableCell,
    CustomEmblem,
    PlayerInvalidActivityIcon
  }
}
</script>

<style lang="scss" scoped>
  .distance-players-table {
    .table-cell {
      &:first-child {
        width:26%;
      }

      &:nth-child(n+2) {
        width: 11%
      }
    }
  }
</style>
